import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
// import { gqlQuery } from "libs/awsLib";
// import { mutationInsertStatistics } from "gql/index";

import { useDispatch } from 'react-redux';
import { trackUser } from "../redux/actions/trackUser";

import {  trackEvent } from "../helpers/userTrack";

const getSessionId = () => {
  let sessionId = localStorage.getItem('session_id');
  if (!sessionId) {
    sessionId = '_' + Math.random().toString(36);
    localStorage.setItem('session_id', sessionId);
  }
  return sessionId;
};

export const useAutoUserTracking = () => { 
  const location = useLocation();
  const  params = useParams();
  const dispatch = useDispatch();



  useEffect(() => {
    const session_id = getSessionId(); 
    const event = trackEvent(location, {}); 
  
    let detail = null;
  
    if (event.from !== event.page) {
      detail = { ...event };
    } else {
      detail = {
        ...event,
        detail: JSON.stringify({ type: 'RELOAD PAGE' }),
      };
    }
  
    dispatch(trackUser({ ...detail, session_id }));
    console.log({ usertrack_auto: detail });


  }, [dispatch, location, params]); 
};


export const useManualUserTracking = () => {
  const dispatch = useDispatch();
  const location = useLocation();


  const trackUserEvent = (detail = {}) => {
    const session_id =  getSessionId();
    const event = trackEvent(location, detail);
    event.event = detail.type || event.event;

    dispatch(trackUser({ ...event, session_id }));
    console.log({ usertrack_manual: event });
  };

  return { trackUserEvent }; 
};

